export default "__VITE_ASSET__CavRQvtf__"